import appReducer from './reducers/index';

import { initialState as loginInitialState } from './reducers/login';

export default function configureStore({ initialState }) {
  const logDeps = [window.reduxThunk];

  if (process.env.NODE_ENV !== 'production') {
    const createLogger = require('redux-logger').createLogger;
    const logger = createLogger();
    logDeps.push(logger);
  }

  const middleware = [
    promiseMiddleware({
      promiseTypeSuffixes: ['START', 'SUCCESS', 'ERROR'],
    }),
    ...logDeps,
  ];

  const createReduxStore = redux.applyMiddleware(...middleware);

  const store = createReduxStore(redux.createStore)(appReducer, {
    login: {
      ...loginInitialState,
      ...initialState.login,
    },
  });

  if (module.hot) {
    module.hot.accept('./reducers/index', () => {
      const nextRootReducer = require('./reducers/index').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
